
<template lang="pug">
focus-trap
  .cnmn-modal
    .cnmn-modal__wrapper
      slot
</template>

<script>
import {FocusTrap} from 'focus-trap-vue'

export default {
  components: {FocusTrap},

  created() {
    this.overflow_ = document.documentElement.style.overflow
    document.documentElement.style.overflow = 'hidden'
  },

  beforeDestroy() {
    document.documentElement.style.overflow = this.overflow_
  },
}
</script>

<style lang="sass">
.cnmn-modal
  background-color: rgba(0, 0, 0, .5)
  bottom: 0
  display: flex
  left: 0
  overflow: auto
  position: fixed
  right: 0
  top: 0
  z-index: 10000

.cnmn-modal__wrapper
  margin: auto
</style>
